import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Star } from "lucide-react";

const clip = (t, n = 90) => (t.length > n ? `${t.slice(0, n).trimEnd()}…` : t);

export const ReviewTicker = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api
      .get("/reviews")
      .then((r) => {
        const five = (r.data?.reviews || []).filter((x) => Math.round(x.rating) === 5 && x.text);
        setItems(five.slice(0, 6).map((x) => ({ text: clip(x.text), author: x.author })));
      })
      .catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <div data-testid="review-ticker" className="overflow-hidden border-y border-brand-red/25 bg-black/80 py-3.5 relative">
      <div className="marquee-track flex gap-14 whitespace-nowrap items-center">
        {[...items, ...items].map((r, i) => (
          <span key={`rt-${i}`} className="inline-flex items-center gap-3">
            <span className="inline-flex gap-0.5">
              {[0, 1, 2, 3, 4].map((s) => (
                <Star key={s} className="h-3 w-3 fill-brand-red text-brand-red" />
              ))}
            </span>
            <span className="text-sm text-zinc-300">&ldquo;{r.text}&rdquo;</span>
            <span className="font-mono text-[10px] uppercase tracking-widest text-brand-red">— {r.author} · Google</span>
            <span className="h-1 w-1 rounded-full bg-brand-red/60" />
          </span>
        ))}
      </div>
    </div>
  );
};
